// extracted by mini-css-extract-plugin
export default {"participant-counts":"AllParticipantsSummary_participant-counts__nlmz2"};